// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"164":"c9d8aa71","872":"6b952597"}[chunkId] + ".chunk.css";
};